import { SettingsPaths } from "Settings/Routes/Routing";
import { UserDetailTab } from "Settings/User/Pages/UserDetailTab";
import type { TabType } from "Shared/Components/Tabs/Types/TabType";

export enum UserProfileTabs {
	detail = "detail",
}

export const getUserProfileTabs = (): TabType[] => [
	{
		index: UserProfileTabs.detail,
		label: "Detail",
		path: SettingsPaths.UserDetail.route,
		tab: <UserDetailTab />,
	},
];
